var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"red"},on:{"contextmenu":function($event){$event.preventDefault();return _vm.$parent.$parent.$parent.$refs.menu.open.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.params.value || ' ')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }